
export default [
  '/Midware',
  '/MessageCenter',
];



// WEBPACK FOOTER //
// ./src/constants/ignoreMenu.js